import { Injectable } from "@angular/core";
import { RemoteGatewayFactory } from "../../gateways/remote-gateway-factory";
import { BackendUrl } from "../../models/domains/urls/back-end.url";
import { ProductCategoryParser } from "../parsers/pbm/benefit/product-category.parser";

@Injectable()
export class ProductCategoryRepository {
  constructor(private remoteGatewayFactory: RemoteGatewayFactory, private productCategoryParser: ProductCategoryParser) {}

  public async getProductCategoryList(): Promise<any> {
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
      const data = await remoteGateway.getWithHeaders(new BackendUrl("/api/products/categories"), headers);
      return this.productCategoryParser.parse(data);
    } catch (error) {
      return await Promise.reject(error);
    }
  }
}
